import { c as _c } from "react/compiler-runtime";
import FeedbackDialog, { useDialog } from './FeedbackDialog';
import PageMain from './PageMain';
interface FeedbackButtonProps {
  isOpenDefault?: boolean;
  shouldHandleGlobalClick?: boolean;
  render: (props: {
    onClick: (e: React.MouseEvent) => void;
  }) => React.ReactNode;
}
export default function FeedbackButton(t0) {
  const $ = _c(18);
  const {
    render,
    isOpenDefault,
    shouldHandleGlobalClick
  } = t0;
  let t1;
  if ($[0] !== isOpenDefault || $[1] !== shouldHandleGlobalClick) {
    t1 = {
      isOpenDefault,
      shouldHandleGlobalClick
    };
    $[0] = isOpenDefault;
    $[1] = shouldHandleGlobalClick;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const {
    isDialogOpen,
    handleOpen,
    handleClose,
    currentPage,
    shouldDisplayBack
  } = useDialog(t1);
  let t2;
  if ($[3] !== handleOpen) {
    t2 = e => {
      e.preventDefault();
      handleOpen();
    };
    $[3] = handleOpen;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== render || $[6] !== t2) {
    t3 = render({
      onClick: t2
    });
    $[5] = render;
    $[6] = t2;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  let t4;
  if ($[8] !== currentPage) {
    t4 = currentPage === "main" && <PageMain />;
    $[8] = currentPage;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  let t5;
  if ($[10] !== handleClose || $[11] !== isDialogOpen || $[12] !== shouldDisplayBack || $[13] !== t4) {
    t5 = <FeedbackDialog isOpen={isDialogOpen} onClose={handleClose} shouldDisplayBack={shouldDisplayBack}>{t4}</FeedbackDialog>;
    $[10] = handleClose;
    $[11] = isDialogOpen;
    $[12] = shouldDisplayBack;
    $[13] = t4;
    $[14] = t5;
  } else {
    t5 = $[14];
  }
  let t6;
  if ($[15] !== t3 || $[16] !== t5) {
    t6 = <>{t3}{t5}</>;
    $[15] = t3;
    $[16] = t5;
    $[17] = t6;
  } else {
    t6 = $[17];
  }
  return t6;
}